module.exports = [
  ...require('./_gearRawList_d'),
  require('./dagger'),
  require('./dart'),
  require('./donkey'),
  require('./double_bladed_scimitar'),
  require('./dungeoneer_s_pack'),
  require('./dynamite_stick'),
]
